import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/catalog',
    name: 'catalog',
    component: () => import('@/views/Catalog.vue')
  },
  {
    path: '/catalog_result',
    name: 'catalogResult',
    component: () => import('@/views/CatalogResult.vue'),
    props: route => route.query
  },
  {
    path: '/station',
    name: 'station',
    component: () => import('@/views/Station.vue')
  },
  {
    path: '/article/:name?',
    name: 'article',
    component: () => import('@/views/Article.vue'),
    props: true
  },
  {
    path: '/links',
    name: 'links',
    component: () => import('@/views/Links.vue')
  },
  {
    path: '/event/:eventid',
    name: 'event',
    component: () => import('@/views/EventPage.vue'),
    props: true
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
